// Maps a BE error code to a translated user-facing message.
// Falls back to the generic error key if the code is missing or untranslated.
import type { TFunction } from 'i18next';

export function getErrorMessage(error: unknown, t: TFunction): string {
  if (error && typeof error === 'object' && 'code' in error) {
    const code = (error as { code?: string }).code;
    if (code) {
      const key = `errors.${code}`;
      const translated = t(key, { ns: 'common' });
      if (translated !== key) return translated;
    }
  }
  return t('errors.generic', { ns: 'common' });
}
